import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import AboutUs from './components/AboutUs';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main className="content">
        <AboutUs />
      </main>
    </div>
  );
}

export default App;
